export const PRODUCT_LIKE = 1;
export const PRODUCT_NEUTRAL = 0;
export const PRODUCT_DISLIKE = -1;

export const DISLIKE_OPTIONS = [
  'Too expensive',
  'Too cheap',
  'Not my style',
  'Material',
  'Color',
  'Wrong size'
];
